import { createFileRoute } from '@tanstack/react-router'
import { ShoppingListsPage } from '_/features/shopping/ui/pages/shopping-lists-page'

export const Route = createFileRoute('/_authenticated/shopping/')({
	staticData: { title: 'shopping_title' },
	component: ShoppingListsPage,
})
